import classNames from 'classnames';
import debounce from 'lodash.debounce';
import {Initials} from './avatar-name';
import {log} from '../../utils/logger';
import {PERSON__16} from '@homeaway/svg-defs';
import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import './avatar.less';

export const DEFAULT_PROFILE_PIC = 'default-profile-pic.png';

export const logEmptyProfile = debounce(log, 500, {
    leading: false,
    trailing: true
});

export const hasProfileImage = (publicImageUrl) => {
    if (typeof publicImageUrl !== 'string' || publicImageUrl === '') {
        return false;
    }
    return publicImageUrl.indexOf(DEFAULT_PROFILE_PIC) === -1;
};

export const isProfileEmpty = (firstName, hasImage = false) => {
    return !(firstName && firstName.length) && !hasImage;
};

export function Avatar({
    className,
    firstName,
    lastName,
    allowEmpty = false,
    publicImageUrl,
    sm = false
}) {
    const hasImage = hasProfileImage(publicImageUrl);
    const isEmpty = isProfileEmpty(firstName, hasImage);
    const avatarClass = classNames({
        'avatar': true,
        'avatar__is-empty': isEmpty,
        'avatar__sm': sm
    });

    if (isEmpty && !allowEmpty) {
        return null;
    }

    // Log in splunk so we can see how often this is happening
    /* istanbul ignore next */
    if (isEmpty) {
        logEmptyProfile({message: 'Empty profile rendered: user profile is empty.'});
    }

    return (
        <span className={`${avatarClass} ${className}`} style={(
            hasImage ? {backgroundImage: `url(${publicImageUrl})`} : {}
        )}
        >
            {isEmpty && <SVGIcon markup={PERSON__16} />}
            {hasImage ? null : <Initials firstName={firstName} lastName={lastName} sm={sm} />}
        </span>
    );
}

Avatar.defaultProps = {
    sm: false
};

export default Avatar;


// WEBPACK FOOTER //
// ./src/universal/tripboard/avatar/avatar.js